import PrimaryLabel from '../../../views/components/Labels/PrimaryLabel';
import Drawer from '../../../views/components/Modals/Drawer';

export const HelpCenterDrawer = ({ visible = false, handleCloseDrawer, children }) => {
  return (
    <Drawer
      headerContents={
        <PrimaryLabel normal className="text-white font-size-18">
          Help Center
        </PrimaryLabel>
      }
      visible={visible}
      onClose={handleCloseDrawer}
      width="55%"
    >
      <div className="h-100 p-30 custom-scroll-bar">{children}</div>
    </Drawer>
  );
};
